module.exports = __webpack_public_path__ + "img/book2.43026d6.png";